import { FilterState } from "view/EmbeddedShows/helpers/filterSortReducer";
import { AnonymousOldShow } from "ts/api/show";
import { parseISO } from "date-fns";

const filterShows = (shows: AnonymousOldShow[], filterState: FilterState) => {
  const { query, sortBy, sortOrder } = filterState;
  let showsCopy = shows.slice();
  if (query) {
    showsCopy = showsCopy.filter((show) => {
      const { venueName = "", name: showName = "" } = show;
      const loweredQuery = query.toLowerCase();
      return (
        venueName.toLowerCase().includes(loweredQuery) ||
        showName.toLowerCase().includes(loweredQuery)
      );
    });
  }
  return showsCopy.sort((a, b) => {
    if (sortBy === "liveStart") {
      return parseISO(a.liveStart).getTime() - parseISO(b.liveStart).getTime();
    }
    return sortOrder === "asc"
      ? a.name.localeCompare(b.name)
      : b.name.localeCompare(a.name);
  });
};
export default filterShows;
